<mat-form-field>
  <mat-select
    [(ngModel)]="flatArea.name"
    placeholder="{{'FLAT.AREA.TYPE' | translate}}">
    <mat-option *ngFor="let type of areaTypes" [value]="type">
      {{type}}
    </mat-option>
  </mat-select>
</mat-form-field>
